
import { BasicController } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { SFConstants } from "../../../../constants/SFConstants";
import { Poker2Model } from "../../../../model/Poker2Model";
import { TurnTimerComponent } from "../../../components/playerContainer/TurnTimerComponent";
import { AniTableHelper } from "../../../helper/AniTableHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class RabbitCam extends Container {
    private RABBIT_CAM_GOLD_COST: number = 1;

    private _view: MovieClip;
    private _rabbitCamView: Library.PokerTable.RabbitCamComponent;
    private _turnTimer: TurnTimerComponent;

    private _aniHelper: AniTableHelper;
    private _btnRabbitCam: RabbitCamButton;
    private _gold: string;

    constructor(aniHelper: AniTableHelper, goldFee: number) {
        super();
        this._aniHelper = aniHelper;

        // costs in gold
        this._gold = (!isNaN(goldFee)) ? goldFee.toString() : this.RABBIT_CAM_GOLD_COST.toString();

        this.build();
        this.buildTimerView();
    }

    private buildTimerView(): void {
        // create register timer
        if (!this._turnTimer) {
            this._turnTimer = new TurnTimerComponent();
            this._turnTimer.onTurnTimerCallbackTrigger = this.bindFunction(this.handleTurnTimerEvent);
            this._rabbitCamView.mc_timerHolder.addChild(this._turnTimer);
        }
    }

    private build(): void {
        this._rabbitCamView = new Library.PokerTable.RabbitCamComponent();
        this._rabbitCamView.changeTextFieldCacheScale(2);
        this._rabbitCamView.x = 549.6;
        this._rabbitCamView.y = 248.75;
        this.addChild(this._rabbitCamView);

        if (!this._btnRabbitCam) {
            this._btnRabbitCam = new RabbitCamButton(this._rabbitCamView.btn_rabbitCam);
        }
        this._btnRabbitCam.label = Poker2Model.languageData.getTextById("table_btn_rabbitcam");
        this._btnRabbitCam.gold = this._gold;
        this._rabbitCamView.btn_rabbitCam.toolTipText = Poker2Model.languageData.getTextById("table_btn_rabbitcam_tooltip");
        this._rabbitCamView.btn_rabbitCam.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
    }

    protected onClick(event: MouseEvent): void {
        BasicModel.smartfoxClient.sendMessage("grc", [JSON.stringify({ id: Poker2Model.userData.playerID })]);

        //
        this.disable();
    }

    public startTimeout(time: number): void {
        this.visible = true;
        this._turnTimer.startTimer(time);
    }

    private handleTurnTimerEvent(progress: number): void {
        switch (progress) {
            case 1:

                this.hide();
                break;
        }
    }

    public enable(): void {
        this.mouseChildren = true;
        this._aniHelper.unGrayscale(this._rabbitCamView);
    }

    public disable(): void {
        this.mouseChildren = false;
        this._aniHelper.grayscale(this._rabbitCamView);
    }

    public hide(): void {
        this.mouseChildren = false;
        this.visible = false;
        this._turnTimer.stopTimer();
    }

    public kill(): void {
        this.hide();
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }
}
import { RabbitCamButton } from "../../../components/button/RabbitCamButton";
classImplementsInterfaces(RabbitCam, "Container");
